import React, { Component } from 'react';
import { CloseIconContainer } from '../style';
import { FormModalContainer, FormModalContent, TabContainer, TabItem, ScrollableWorkoutsContainer } from './style';
import { Text } from '../../../UI/Text';
import { connect } from 'react-redux';
import { handleLoginService } from '../../../../Services/handleLocalStorage';
import TabSwitcher, { Tab, TabPanel } from '../../../Context/TabsContext';
import { SelectablePlans } from '../../../Containers/PlannedWorkouts/Plans';
import { Loading } from '../../../Containers/WithLoading/Loading';
import { HoverableLink } from '../../../Layouts';
import { EmptyWorkoutCard } from '../../../Containers/PlannedWorkouts/WorkoutCard';
import { EmptyState } from '../../../Containers/WithEmptyState/EmptyState';
import { PlannedWorkoutsEmptyState, NoWorkoutsFound } from '../../BannerEmptyStats/BannerEmptyStats';
import { ChooseLeaderboardsModal } from '../GymTvConfigurationsModal/Modals/ChooseGeneralLeaderboardsModal';
import { WorkoutActionCreators } from '../../../../Store/ActionCreators/WorkoutsActionCreators';
import { ActivityActionCreators } from '../../../../Store/ActionCreators/ActivityActionCreators';

const WORKOUT_OF_THE_DAY_BY_TONA_ID = 315;
const CURRENT_USER_ID = handleLoginService.getUserId();
const WEEK_CHALLENGE_TITLE = 'Add challenge of the week';
const DAILY_CHALLENGE_TITLE = 'Add workout of the day';

class AddWorkoutChallengeModal extends Component {
    state = {
        userIdForWorkoutSearch: handleLoginService.getUserId(),
    };

    componentDidMount() {
        const { userIdForWorkoutSearch } = this.state;
        this.props.getPlannedWorkouts(userIdForWorkoutSearch);
        this.props.getWorkouts(userIdForWorkoutSearch);
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.userIdForWorkoutSearch !== this.state.userIdForWorkoutSearch) {
            this.props.getWorkouts(this.state.userIdForWorkoutSearch);
        }
    }

    switchUser = id => {
        this.setState({ userIdForWorkoutSearch: id });
    };

    reload = () => {
        window.location.reload();
    };

    addWorkout = workoutId => {
        const { type, addWorkoutOfTheDay, addWorkoutOfTheWeek } = this.props;

        switch (type) {
            case 0:
                addWorkoutOfTheDay(workoutId, () => this.reload());
                break;
            case 1:
                addWorkoutOfTheWeek(workoutId, () => this.reload());
                break;
            default:
                break;
        }
    };

    addLeaderboards = workoutId => {
        this.setState({ nextWindowOpen: true, lbWorkoutIdSelected: workoutId });
    };

    addGymTvWorkout = workoutId => {
        this.props.onSelect(this.props.initialModalType, {
            type: this.props.initialModalType,
            content_type: this.props.itemId,
            workout_id: workoutId,
        });
    };

    addClickHandler = workoutId => {
        if (this.props.notForLeaderboards) this.addGymTvWorkout(workoutId);
        else if (this.props.isGymTv) this.addLeaderboards(workoutId);
        else this.addWorkout(workoutId);
    };

    render() {
        const {
            onClose,
            type,
            plannedWorkoutsLoading,
            plannedWorkouts,
            isActivityLoading,
            activity,
            isGymTv,
            title,
            ...props
        } = this.props;
        const { nextWindowOpen, lbWorkoutIdSelected } = this.state;

        return nextWindowOpen ? (
            <ChooseLeaderboardsModal
                type={4}
                workoutIdSelected={lbWorkoutIdSelected}
                onClose={onClose}
                title={'Choose workout leaderboards'}
                {...props}
            />
        ) : (
            <FormModalContainer>
                <FormModalContent>
                    <Text alignCenter marginBottom={'10px'} fontSize={22} weight={'bold'}>
                        {title ? title : type ? WEEK_CHALLENGE_TITLE : DAILY_CHALLENGE_TITLE}
                    </Text>

                    <TabSwitcher>
                        <TabContainer>
                            <Tab id={0}>
                                <TabItem first={true}>New</TabItem>
                            </Tab>
                            <Tab id={1}>
                                <TabItem onClick={() => this.switchUser(CURRENT_USER_ID)}>Previous</TabItem>
                            </Tab>
                            <Tab id={2}>
                                <TabItem onClick={() => this.switchUser(WORKOUT_OF_THE_DAY_BY_TONA_ID)} last={true}>
                                    From Tona
                                </TabItem>
                            </Tab>
                        </TabContainer>

                        <TabPanel whenActive={0}>
                            <ScrollableWorkoutsContainer>
                                <Loading isLoading={plannedWorkoutsLoading}>
                                    <EmptyState
                                        isEmpty={plannedWorkouts.length === 0}
                                        emptyState={PlannedWorkoutsEmptyState}
                                    >
                                        <HoverableLink target={'_blank'} to={`/planner`}>
                                            <EmptyWorkoutCard />
                                        </HoverableLink>
                                        <SelectablePlans
                                            onClick={this.addClickHandler}
                                            plannedWorkouts={plannedWorkouts}
                                        />
                                    </EmptyState>
                                </Loading>
                            </ScrollableWorkoutsContainer>
                        </TabPanel>

                        <TabPanel whenActive={1}>
                            <ScrollableWorkoutsContainer>
                                <Loading isLoading={isActivityLoading}>
                                    <EmptyState isEmpty={activity.length === 0} emptyState={NoWorkoutsFound}>
                                        <SelectablePlans onClick={this.addClickHandler} plannedWorkouts={activity} />
                                    </EmptyState>
                                </Loading>
                            </ScrollableWorkoutsContainer>
                        </TabPanel>

                        <TabPanel whenActive={2}>
                            <ScrollableWorkoutsContainer>
                                <Loading isLoading={isActivityLoading}>
                                    <EmptyState isEmpty={activity.length === 0} emptyState={NoWorkoutsFound}>
                                        <SelectablePlans onClick={this.addClickHandler} plannedWorkouts={activity} />
                                    </EmptyState>
                                </Loading>
                            </ScrollableWorkoutsContainer>
                        </TabPanel>
                    </TabSwitcher>

                    <CloseIconContainer onClick={() => onClose(null)}>
                        <i className="fas fa-times" />
                    </CloseIconContainer>
                </FormModalContent>
            </FormModalContainer>
        );
    }
}

const mapStateToProps = ({
    workout: {
        statuses: { plannedWorkoutsLoading, isWorkoutOfTheWeekAdding, isWorkoutOfTheDayAdding },
        plannedWorkouts,
    },
    activity: {
        statuses: { isActivityLoading },
        activity,
    },
    user: {
        currentUserPreferences: { metric },
    },
}) => ({
    plannedWorkoutsLoading,
    plannedWorkouts,
    isActivityLoading,
    activity,
    metric,
    isWorkoutOfTheDayAdding,
    isWorkoutOfTheWeekAdding,
});

const mapDispatchToProps = dispatch => ({
    getPlannedWorkouts: id => dispatch(WorkoutActionCreators.getPlannedWorkoutsRequest(id)),
    getWorkouts: id => dispatch(ActivityActionCreators.getProfileActivityRequest(id)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(AddWorkoutChallengeModal);



// WEBPACK FOOTER //
// ./src/UI/Components/Modals/AddWorkoutChallengeModal/index.js